import { SiExpress } from "react-icons/si";
import { TbBrandNextjs } from "react-icons/tb";

export const html = {
  title: "HTML",
  img: "https://cdn-icons-png.flaticon.com/512/1532/1532556.png",
  wid: "70%",
  swid: "40%",
};

export const css = {
  title: "CSS",
  img: "https://cdn4.iconfinder.com/data/icons/iconsimple-programming/512/css-512.png",
  wid: "65%",
  swid: "40%",
};

export const javascript = {
  title: "JavaScript",
  img: "https://cdn-icons-png.flaticon.com/512/5968/5968292.png",
  wid: "60%",
  swid: "40%",
};

export const react = {
  title: "React.js",
  img: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png",
  wid: "75%",
  swid: "40%",
};

export const chakra = {
  title: "Chakra UI",
  img: "https://img.icons8.com/color/512/chakra-ui.png",
  wid: "75%",
  swid: "40%",
};

export const redux = {
  title: "Redux",
  img: "https://cdn.iconscout.com/icon/free/png-256/free-redux-283024.png",
  wid: "70%",
  swid: "40%",
};

export const chartjs = {
  title: "Chart.js",
  img: "https://www.richardwestenra.com/painting-with-data-talk/img/libs/recharts.png",
  wid: "100%",
  swid: "",
};

export const node = {
  title: "Node.js",
  img: "https://cdn-icons-png.flaticon.com/512/5968/5968322.png",
  wid: "65%",
  swid: "40%",
};

export const mongodb = {
  title: "MongoDB",
  img: "https://devkico.itexto.com.br/wp-content/uploads/2013/10/mongodb-leaf-300x300.png",
  wid: "65%",
  swid: "40%",
};

export const express = {
  title: "Express",
  img: "https://cdn.icon-icons.com/icons2/2699/PNG/512/expressjs_logo_icon_169185.png",
  svg: SiExpress,
  wid: "60%",
  swid: "40%",
};

export const tailwind = {
  title: "Tailwind CSS",
  img: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/2048px-Tailwind_CSS_Logo.svg.png",
  wid: "65%",
  swid: "40%",
};

export const nextjs = {
  title: "Next.js",
  img: "https://www.svgrepo.com/show/354113/nextjs-icon.svg",
  wid: "65%",
  svg: TbBrandNextjs,
  swid: "36%",
};

export const git = {
  title: "Git",
  img: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
  wid: "65%",
  swid: "40%",
};

export const typescript = {
  title: "TypeScript",
  img: "https://w7.pngwing.com/pngs/915/519/png-transparent-typescript-hd-logo-thumbnail.png",
  wid: "65%",
  swid: "40%",
};

export const python = {
  title: "Python",
  img: "https://img.freepik.com/free-icon/snakes_318-368381.jpg",
  wid: "70%",
  swid: "40%",
};

export const promptEngineering = {
  title: "Prompt Engineering",
  img: "https://static.vecteezy.com/system/resources/previews/021/495/996/original/chatgpt-openai-logo-icon-free-png.png",
  wid: "70%",
  swid: "35%",
};

export const mySQL = {
  title: "MySQL",
  img: "https://www.notion.so/image/https%3A%2F%2Fpngimg.com%2Fd%2Fmysql_PNG9.png?table=block&id=27e6b5e3-e888-4802-9c0b-2e5ca6bdf31a&spaceId=5247e3c7-a9ff-4596-9c82-e08b13f4ea9d&width=250&userId=af1a9bd4-c5ca-4c4b-88f4-f0e87ce2512a&cache=v2",
  wid: "70%",
  swid: "35%",
};
